import createModule from "../createModule"
import { getIsBasicAuth, getSsoProvider, getUserMfaEnabled, getErrorMessage, getPasswordExpired, getRedirectUrl, getSelectedEmail, getRequireMfa, getRequireCaptcha, getIsRefreshMode, getTitle, getSubTitle, getServerRedirectUrl, getErrorCode } from "./selectors/index"
import { Creators } from "./model"
import view from "./view"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    user: state.user,
    isBasicAuth: getIsBasicAuth(state, props),
    selectedEmail: getSelectedEmail(state, props),
    errorMessage: getErrorMessage(state, props),
    redirect: getRedirectUrl(state, props),
    requireMfa: getRequireMfa(state, props),
    requireCaptcha: getRequireCaptcha(state, props),
    ssoProvider: getSsoProvider(state),
    isRefreshMode: getIsRefreshMode(state, props),
    title: getTitle(state, props),
    subTitle: getSubTitle(state, props),
    userMfaEnabled: getUserMfaEnabled(state),
    passwordExpired: getPasswordExpired(state),
    serverRedirect: getServerRedirectUrl(state, props),
    errorCode: getErrorCode(state, props),
  }),
  actions: {
    ...Creators,
  },
})
